webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _AddVocab = __webpack_require__(37);
	
	var _AddVocab2 = _interopRequireDefault(_AddVocab);
	
	var _App = __webpack_require__(90);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _NotFound = __webpack_require__(91);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _QuestionVocab = __webpack_require__(38);
	
	var _QuestionVocab2 = _interopRequireDefault(_QuestionVocab);
	
	var _vueRouter = __webpack_require__(98);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vue = __webpack_require__(99);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/', redirect: '/question' }, { path: '/question', component: _QuestionVocab2.default }, { path: '/question/:word', component: _QuestionVocab2.default }, { path: '/add', component: _AddVocab2.default }, { path: '/notfound', component: _NotFound2.default }, { path: '*', component: _NotFound2.default }];
	
	var router = new _vueRouter2.default({
		mode: 'history',
		routes: routes,
		scrollBehavior: function scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition;
			} else {
				return {
					x: 0,
					y: 0
				};
			}
		}
	});
	
	new _vue2.default({
		router: router,
		el: '#app',
		template: '<App/>',
		components: { App: _App2.default }
	});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(88)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(40),
	  /* template */
	  __webpack_require__(96),
	  /* scopeId */
	  "data-v-6c673c68",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(42),
	  /* template */
	  __webpack_require__(93),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _AddVocab = __webpack_require__(37);
	
	var _AddVocab2 = _interopRequireDefault(_AddVocab);
	
	var _QuestionVocab = __webpack_require__(38);
	
	var _QuestionVocab2 = _interopRequireDefault(_QuestionVocab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		components: { AddVocab: _AddVocab2.default, QuestionVocab: _QuestionVocab2.default }
	};

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(25);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'AddVocab',
		data: function data() {
			return {
				lang1: null,
				lang2: null,
				saved: true,
				stage: 'addForeign'
			};
		},
	
		methods: {
			save: function save() {
				var _this = this;
	
				if (this.lang1 && this.lang1 !== '' && this.lang2 && this.lang2 !== '') {
					this.saved = false;
					fetch('https://vocabtrainer-4ddc9.firebaseio.com/vocabs.json', {
						method: 'POST',
						body: (0, _stringify2.default)({
							lang1: this.lang1, lang2: this.lang2, updatedAt: Math.round(Date.now() / 1000)
						})
					}).then(function (res) {
						if (res.ok) {
							return res.blob;
						}
						throw new Error('Network response was not ok.');
					}).then(function (myBlob) {
						_this.lang1 = null;
						_this.lang2 = null;
						_this.saved = true;
						_this.stage = 'addForeign';
					}).catch(function (error) {
						return console.log('There has been a problem with your fetch operation: ' + error.message);
					});
				}
			}
		}
	};

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'notFound',
		data: function data() {
			return { msg: 'ERROR: NotFound' };
		}
	};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(44);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(45);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(46);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _VocabCardQuestion = __webpack_require__(92);
	
	var _VocabCardQuestion2 = _interopRequireDefault(_VocabCardQuestion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'questionVocab',
		created: function created() {
			this.fetchData();
		},
	
		components: { VocabCardQuestion: _VocabCardQuestion2.default },
		data: function data() {
			return {
				error: null,
				loading: false,
				vocabCurrent: {},
				vocabs: []
			};
		},
	
		methods: {
			validateStatus: function validateStatus(response) {
				this.loading = false;
				if (response.status >= 200 && response.status < 300) {
					return _promise2.default.resolve(response);
				} else if (response.status === 404) {
					this.$router.push('/notfound');
					return _promise2.default.reject();
				} else {
					console.log(response);
					return _promise2.default.reject(new Error(response.statusText));
				}
			},
			jsonify: function jsonify(response) {
				return response.json();
			},
			fetchData: function fetchData() {
				var _this = this;
	
				this.error = this.post = null;
				this.loading = true;
				var vocabs = [];
	
				fetch('https://vocabtrainer-4ddc9.firebaseio.com/vocabs.json').then(this.validateStatus).then(this.jsonify).then(function (data) {
					(0, _keys2.default)(data).forEach(function (key) {
						var vocab = data[key];
						vocab.id = key;
						vocabs.push(vocab);
					});
					_this.vocabs = vocabs;
					_this.vocabCurrent = _this.getVocabCurrent();
				}).catch(function (error) {
					_this.error = error.toString();
				});
			},
			getVocabCurrent: function getVocabCurrent(prev) {
				var selector = this.$route.params.word || '';
				var antiSelector = prev || '';
				var filtered = this.vocabs.filter(function (vocab) {
					if (selector.length > 0) {
						return selector.split(' ').filter(function (filterterm) {
							return vocab.lang1.toLowerCase().includes(filterterm.replace(/\+/ig, ' ').toLowerCase());
						}).length === selector.split(' ').length;
					} else {
						return vocab.lang1 !== antiSelector;
					}
				}).map(function (vocab) {
					var historicData = localStorage.getItem(vocab.id) ? JSON.parse(localStorage.getItem(vocab.id)) : false;
					vocab = (0, _assign2.default)(vocab, historicData || { noTotal: 0, noWrong: 0 });
	
					return vocab;
				}).sort(function (v1, v2) {
					var v1ErrorRate = v1.noTotal === 0 ? v1.noWrong / v1.noTotal : 0;
					var v2ErrorRate = v2.noTotal === 0 ? v2.noWrong / v2.noTotal : 0;
					var v1v2NoQuestioned = v1.noTotal && v2.noTotal ? v1.noTotal / v2.noTotal : 0;
	
					if (v1v2NoQuestioned <= 1 / 3 || v1v2NoQuestioned >= 3) {
						return v1.noTotal - v2.noTotal;
					} else {
							return v2ErrorRate - v1ErrorRate;
						}
				});
	
				var current = filtered[0];
	
				if (current && current.lang1.replace('/', '') !== selector) {
					this.$router.replace({ path: '/question/' + encodeURI(current.lang1.replace('/', '')) });
				}
				return current;
			}
		},
		watch: {
			'$route': function $route(to, from) {
				this.vocabCurrent = this.getVocabCurrent(from.params.word);
			}
		}
	};

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(25);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'VocabCard',
		data: function data() {
			return { stage: 'showQuestion' };
		},
	
		props: {
			vocab: {
				type: Object,
				default: function _default() {
					return {
						id: '',
						lang1: '',
						lang2: '',
						updatedAt: ''
					};
				}
			}
		},
		methods: {
			answer: function answer(wasCorrect) {
				var vocabId = this.vocab.id;
				var historicData = localStorage.getItem(vocabId) ? JSON.parse(localStorage.getItem(vocabId)) : false;
	
				if (historicData) {
					historicData.noTotal++;
					historicData.noWrong += wasCorrect ? 0 : 1;
					historicData.lastQuestioned = new Date();
				} else {
					historicData = {
						noTotal: 1,
						noWrong: wasCorrect ? 0 : 1,
						lastQuestioned: new Date()
					};
				}
	
				localStorage.setItem(vocabId, (0, _stringify2.default)(historicData));
	
				this.$router.push({ path: '/question' });
			},
			next: function next() {
				if (this.stage === 'showQuestion') {
					this.stage = 'showAnswer';
				} else if (this.stage === 'showAnswer') {
					this.stage = 'showRating';
				} else {
					this.stage = 'showQuestion';
				}
			}
		}
	};

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(87)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(39),
	  /* template */
	  __webpack_require__(95),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(86)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(41),
	  /* template */
	  __webpack_require__(94),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(89)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(43),
	  /* template */
	  __webpack_require__(97),
	  /* scopeId */
	  "data-v-782846e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.vocabCurrent) ? _c('VocabCardQuestion', {
	    key: _vm.vocabCurrent.id,
	    attrs: {
	      "vocab": _vm.vocabCurrent
	    }
	  }) : (_vm.loading) ? _c('div', {
	    staticClass: "loading"
	  }, [_vm._v("\n\tLOADING...\n")]) : (_vm.error) ? _c('div', {
	    staticClass: "error"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.error))])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notFound"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])])
	},staticRenderFns: []}

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('nav', [_c('router-link', {
	    staticClass: "nav_add",
	    attrs: {
	      "to": "/add",
	      "title": "add vocabulary"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 112 113"
	    }
	  }, [_c('text', {
	    attrs: {
	      "x": "-10px",
	      "y": "112.08px"
	    }
	  }, [_vm._v("+")])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "nav_question",
	    attrs: {
	      "to": "/",
	      "title": "ask me vocabulary"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "viewBox": "0 0 102 162"
	    }
	  }, [_c('text', {
	    attrs: {
	      "x": "-10px",
	      "y": "161.08px"
	    }
	  }, [_vm._v("?")])])])], 1), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.saved) ? _c('article', [(_vm.stage === 'addForeign') ? [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.lang2),
	      expression: "lang2",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    attrs: {
	      "placeholder": "Foreign Language",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.lang2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lang2 = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "addNative",
	    on: {
	      "click": function($event) {
	        _vm.stage = 'addNative'
	      }
	    }
	  }, [_vm._v("Next")])] : (_vm.stage === 'addNative') ? [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.lang1),
	      expression: "lang1",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    attrs: {
	      "placeholder": "Native Language",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.lang1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lang1 = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "save",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Add")])] : _vm._e()], 2) : _c('article', [_vm._v("\n\tsaving...\n")])
	},staticRenderFns: []}

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.vocab) ? _c('article', [_vm._v("loading...")]) : _c('article', {
	    on: {
	      "click": _vm.next
	    }
	  }, [(_vm.stage === 'showQuestion') ? _c('section', {
	    staticClass: "question",
	    on: {
	      "click": function($event) {
	        _vm.stage = 'showAnswer'
	      }
	    }
	  }, [_vm._v("\n\t\t" + _vm._s(_vm.vocab.lang1) + "\n\t")]) : (_vm.stage === 'showAnswer') ? _c('section', {
	    staticClass: "answer",
	    on: {
	      "click": function($event) {
	        _vm.stage = 'showRating'
	      }
	    }
	  }, [_vm._v("\n\t\t" + _vm._s(_vm.vocab.lang2) + "\n\t")]) : [_c('button', {
	    staticClass: "rating wrong",
	    on: {
	      "click": function($event) {
	        _vm.answer(false)
	      }
	    }
	  }, [_c('div', [_vm._v(": (")])]), _vm._v(" "), _c('button', {
	    staticClass: "rating right",
	    attrs: {
	      "autofocus": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.answer(true)
	      }
	    }
	  }, [_c('div', [_vm._v(": )")])])]], 2)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.8670d074233d5a539cc7.js